import { CurrencyPipe, formatNumber } from '@angular/common';
import { Option } from '@com-delta-omnichannel/aura';
import {
  CURRENCY,
  MILES,
  MembershipDetails,
  NewMembershipOptions,
  Options
} from '../models';

export const createCurrencyOption = (
  value: number,
  currencyCode: string,
  label: string
): Option => ({
  value: new CurrencyPipe('en-US').transform(value, currencyCode) as string,
  label,
  selected: false
});

export const createMilesOption = (value: number, label: string): Option => ({
  value: `${formatNumber(value, 'en-US', '1.0')}${MILES}`,
  label,
  selected: false
});

export const createOptionForMembershipType = (
  key: string,
  membershipTypeOptions: NewMembershipOptions,
  aemContent: Options[]
): Options => {
  const membershipDetailsArray =
    membershipTypeOptions[key as keyof NewMembershipOptions];
  if (!membershipDetailsArray) {
    return {} as Options;
  }
  const currencies = createCurrencyOptions(membershipDetailsArray, aemContent);
  return {
    type: {
      title: key,
      subtitle: aemContent[0].type.subtitle,
      content: membershipDetailsArray[0]?.expirationDate
    },
    currencies,
    membershipDetails: membershipDetailsArray as MembershipDetails[]
  };
};

export const createCurrencyOptions = (
  membershipDetails: MembershipDetails[],
  aemContent: Options[]
): Option[] => {
  return membershipDetails.map((element) => {
    if (element.denomination === CURRENCY) {
      return createCurrencyOption(
        element.shoppingValue,
        element.currencyCode,
        aemContent[0].currencies[0].label
      );
    }
    return createMilesOption(
      element.shoppingValue,
      aemContent[0].currencies[1].label
    );
  });
};
